import { Organization } from '../../models/organization';
import { EActions } from '../../redux/actions/EActions';

export function OrganizationSuccess(org: Organization) {
  return {
    type: EActions.OrganizationSuccess,
    payload: org,
  };
}

export function OrganizationSwitch(org: Organization) {
  return {
    type: EActions.OrganizationSwitch,
    payload: org,
  };
}

// TODO: Insert text so the user can start typing and filter by user name
// export function GetOrganizationUsers(org: Organization) {
//   return async (dispatch: Function) => {
//     dispatch(EActions.OrganizationUsers);
//     try {
//       const result = await OrganizationService.GetUsers(org.id, 100, 1);
//       return dispatch({
//         type: EActions.OrganizationUsersSuccess,
//         payload: result,
//       });
//     } catch (error) {}
//   };
// }
